import $ from 'jquery';
import initSwiper from '../utils/swiper';

const blog = {
	init() {
		this.instagramSwiper();
		this.relatedProductsSwiper();
		this.categoryFilter();
		this.setupLoadMore();
		this.stickyFilterBar();
	},

	relatedProductsSwiper() {
		const selector = '.__related_products_swiper';

		if (!document.querySelector(selector)) {
			return;
		}

		initSwiper(selector, {
			loop: false,
			centeredSlides: false,
			slideToClickedSlide: false,
			spaceBetween: 20,
			navigation: true,
			navigationEls: {
				nextEl: '.__related_products_next',
				prevEl: '.__related_products_prev',
			},
			autoplay: false,
			watchOverflow: true,
			breakpoints: {
				0: {slidesPerView: 1.15, spaceBetween: 14},
				576: {slidesPerView: 2.05, spaceBetween: 16},
				992: {slidesPerView: 3.2, spaceBetween: 20},
				1200: {slidesPerView: 4.2, spaceBetween: 20},
			},
		});
	},

	// La barre de filtre n'a de fond (plein ecran) que lorsqu'elle est
	// reellement collee sous le header - position:sticky seul ne permet pas
	// de detecter cet etat en CSS, on passe donc par un sentinelle observe
	// en IntersectionObserver : des qu'il sort du viewport, la barre est
	// "stuck".
	stickyFilterBar() {
		const sentinel = document.querySelector('.__blog_filter_sentinel');
		const bar = document.querySelector('._contain_filters');

		if (!sentinel || !bar || !('IntersectionObserver' in window)) {
			return;
		}

		const observer = new IntersectionObserver(([entry]) => {
			bar.classList.toggle('_stuck', !entry.isIntersecting);
		}, {threshold: 0});

		observer.observe(sentinel);
	},

	setupLoadMore() {
		$(document).on('click', '.--blog_load_more_btn', function () {
			const $btn = $(this);

			if ($btn.hasClass('_loading')) {
				return;
			}

			$btn.addClass('_loading');

			$.post(`${_SITE_URL}more-blog-articles`, {}, (response) => {
				const data = JSON.parse(response);
				$('#__blog_articles_grid').append(data.articles);

				if (data.nb_inview >= data.nb_total) {
					$('.__blog_load_more').hide();
				}
			}).always(() => {
				$btn.removeClass('_loading');
			});
		});
	},

	categoryFilter() {
		const $bar = $('.__blog_filter_bar');

		if (!$bar.length) {
			return;
		}

		$(document).on('click', '.__blog_filter_trigger', (e) => {
			e.stopPropagation();
			const isOpen = $bar.hasClass('_open');
			$bar.toggleClass('_open', !isOpen);
			$('.__blog_filter_trigger').attr('aria-expanded', String(!isOpen));
		});

		$(document).on('click', (e) => {
			if (!e.target.closest('.__blog_filter_bar')) {
				$bar.removeClass('_open');
				$('.__blog_filter_trigger').attr('aria-expanded', 'false');
			}
		});

		$(document).on('keydown', (e) => {
			if (e.key === 'Escape') {
				$bar.removeClass('_open');
				$('.__blog_filter_trigger').attr('aria-expanded', 'false');
			}
		});
	},

	// Uniquement la version mobile (".__instagram_mobile_swiper") : desktop
	// et tablette utilisent desormais une mosaique CSS Grid statique
	// (".__instagram_mosaic", cf. blog_instagram.php), pas de swiper - rendu
	// "editorial" plutot qu'un carrousel generique, cf. retours utilisateur.
	instagramSwiper() {
		const selector = '.__instagram_mobile_swiper';

		if (!document.querySelector(selector)) {
			return;
		}

		initSwiper(selector, {
			loop: false,
			centeredSlides: false,
			slideToClickedSlide: false,
			spaceBetween: 14,
			navigation: false,
			autoplay: false,
			slidesPerView: 1.15,
		});
	},
};

export default blog;
